import React, {Component} from 'react';
import CargosStore from 'stores/CargosStore';
import RouteStore from 'stores/RouteStore';
import InstantBookingStore from 'stores/InstantBookingStore';

import './InstantBookingProgressBarPane.scss';

function getStateFromStores() {
    return {
        cargos: CargosStore.getDeliveryCargos(),
        locations: RouteStore.getLocations(),
        date: InstantBookingStore.getPartDay(),
    };
}

class InstantBookingProgressBarPane extends Component {
    state = {
        ...getStateFromStores(),
        precentage: 100,
        confirmedRoute: false,
        confirmedCargos: false,
        confirmedDate: false,
    };

    componentWillMount() {
        this._checkRoute();
        this._checkCargos();
        this._checkDate();
    }

    componentDidMount() {
        RouteStore.addChangeListener(this._onChange);
        CargosStore.addChangeListener(this._onChange);
        InstantBookingStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        RouteStore.removeChangeListener(this._onChange);
        CargosStore.removeChangeListener(this._onChange);
        InstantBookingStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(getStateFromStores(), () => {
            this._checkRoute();
            this._checkCargos();
            this._checkDate();
        });
    };

    _checkRoute = () => {
        if (this.state.locations) {
            if (this.state.locations.from[0] && this.state.locations.to[0]) {
                if (this.state.locations.from[0].text && this.state.locations.to[0].text) {
                    this.setState({
                        confirmedRoute: true,
                        /*precentage: 90,*/
                    });
                } else {
                    this.setState({
                        confirmedRoute: false,
                        /*precentage: 70,*/
                    });
                }
            } else {
                this.setState({
                    confirmedRoute: false,
                });
            }
        } else {
            this.setState({
                confirmedRoute: false,
            });
        }
    };

    _checkCargos = () => {
        if (this.state.cargos && this.state.cargos.size > 0) {
            this.setState({
                confirmedCargos: true,
                /*precentage: 40,*/
            });
        } else {
            this.setState({
                confirmedCargos: false,
                /*precentage: 0,*/
            });
        }
    };

    _checkDate = () => {
        if (this.state.date.size) {
            this.setState({
                confirmedDate: true,
                /*precentage: 100,*/
            });
        } else {
            this.setState({
                confirmedDate: false,
            });
        }
    };

    render() {
        let {
            precentage,
            confirmedRoute,
            confirmedCargos,
            confirmedDate,
        } = this.state;

        return (
            <div className="InstantBookingProgressBarPane">

                <div className="InstantBooking-ProgressBarPane">
                    <div className="ProgressBarPane-filler" style={{width: `${precentage}%`}}></div>
                </div>

                <div className="ProgressBarPane-steps">
                    <div className={`step ${precentage >= 0 && precentage < 50 ? 'step-active' : ''} ${confirmedCargos ? 'step-completed' : ''}`}>
                        <span className="point"></span>
                        <span className="label">Грузы</span>
                    </div>
                    <div className={`step ${precentage >= 50 && precentage < 100 ? 'step-active' : ''} ${confirmedRoute ? 'step-completed' : ''}`}>
                        <span className="point"></span>
                        <span className="label">Маршрут</span>
                    </div>
                    <div className={`step ${precentage === 100 ? 'step-active' : ''} ${confirmedDate ? 'step-completed' : ''}`}>
                        <span className="point"></span>
                        <span className="label">Дата перевозки</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default InstantBookingProgressBarPane;



// WEBPACK FOOTER //
// ./client/components/InstantBookingProgressBarPane/InstantBookingProgressBarPane.js